import { useMantineColorScheme } from "@mantine/core"

import { useSuspenseQueryGet } from "../../../../typed-client/hooks/use-suspense-query-get"
import dayjs from "dayjs"

export function useBackgroundColorForDate(date: Date, isHoliday?: boolean) {
  const { colorScheme } = useMantineColorScheme()

  const { data: colors } = useSuspenseQueryGet("/api/Color/GetColors", {
    colors:
      colorScheme === "dark"
        ? [
            "TodayBackColorDark",
            "HolidayBackColorDark",
            "SaturdayBackColorDark",
            "SundayBackColorDark",
          ]
        : ["TodayBackColor", "Holiday", "Saturday", "Sunday"],
  })

  return dayjs(date).isToday()
    ? colors[0]
    : isHoliday
      ? colors[1]
      : date.getDay() === 6
        ? colors[2]
        : date.getDay() === 0
          ? colors[3]
          : undefined
}
export function useSchoolHolidayColor() {
  const { colorScheme } = useMantineColorScheme()

  const { data: colors } = useSuspenseQueryGet("/api/Color/GetColors", {
    colors:
      colorScheme === "dark"
        ? ["SchoolHolidaysBackColorDark"]
        : ["SchoolHolidaysBackColor"],
  })

  return colors[0]
}
